import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import swal from "sweetalert";
import socketIOClient from "socket.io-client";
import { API_URL, APP_URL, APP_CHECKER, APP_ID } from "../config";
import "./SignIn.css";
import RightSide from "./RightSide";
import { Copy } from "lucide-react";
import bgLogin from "../assets/bgLogin.svg";

const SignIn = () => {
  const [formValues, setFormValues] = useState({
    user_name: "",
    user_password: "",
  });
  const [ajaxReqStatus, setAjaxReqStatus] = useState(false);
  const [open, setOpen] = useState(false);

  const userNameRef = useRef(null);
  const userPassRef = useRef(null);

  useEffect(() => {
    try {
      const socket = socketIOClient(API_URL, {
        transports: ["polling", "websocket"],
        reconnectionDelay: 1000,
        reconnection: true,
        reconnectionDelayMax: 5000,
        reconnectionAttempts: 5,
      });
      
      socket.on("connect", () => {
        console.log("Socket connected");
        setOpen(false);
      });
      
      socket.on("connect_error", (error) => {
        console.warn("Socket connection error:", error);
        setOpen(true);
      });
      
      socket.on("disconnect", (reason) => {
        console.warn("Socket disconnected:", reason);
        if (reason !== "io client namespace disconnect") {
          setOpen(true);
        }
      });
      
      socket.on("error", (error) => {
        console.error("Socket error:", error);
        setOpen(true);
      });

      return () => {
        try {
          socket.disconnect();
        } catch (_err) {
          // ignore disconnect errors
        }
      };
    } catch (error) {
      console.error("Socket initialization error:", error);
      setOpen(true);
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const signinAction = async () => {
    if (!formValues.user_name) {
      swal({ title: "Username is required", icon: "warning" });
      return;
    }
    if (!formValues.user_password) {
      swal({ title: "Password is required", icon: "warning" });
      return;
    }
    if (formValues.user_password.length < 6) {
      swal({ title: "Password should be minimum 6 characters", icon: "warning" });
      return;
    }

    setAjaxReqStatus(true);
    let status = "YES";

    let payload = {
      user_name: formValues.user_name,
      user_password: formValues.user_password,
      username: formValues.user_name,
      password: formValues.user_password,
    };
    try {
      if (APP_ID !== "lifetime") {
        const res = await axios.post(`${APP_CHECKER}/public/app-checker`, {
          appId: APP_ID,
        });
        if (res.data.active === "NO") status = "NO";
      }

      if (status === "NO") {
        setAjaxReqStatus(false);
        swal({ title: "Plz Pay Your Bill... 01813320587", icon: "warning" });
        return;
      }

      const res = await axios.post(`${API_URL}/signin`, payload, {
        headers: { "Content-Type": "application/json" },
      });
      setAjaxReqStatus(false);

      if (!res.data.error) {
        sessionStorage.setItem("auth_info", JSON.stringify(res.data));
        window.location.href = APP_URL;
      } else {
        swal({ title: res.data.message, icon: "warning" });
      }
    } catch (error) {
      setAjaxReqStatus(false);
      const errorData = error?.response?.data;
      const errorMessage =
        errorData?.message ||
        errorData?.error ||
        error?.message ||
        "An error occurred during sign in. Please try again.";
      
      console.error("Sign in error:", {
        status: error?.response?.status,
        message: errorMessage,
        body: payload,
        data: error?.response?.data,
        url: error?.config?.url,
      });
      
      swal({ title: errorMessage, icon: "error" });
    }
  };

  const copyCredentials = (text) => {
    navigator.clipboard.writeText(
      `${text}`
    );
  };


  return (
    <div className="mainlog">
      <div className="signin-wrapper">
        {/* Header */}
        <div className="signin-wrapper2"
          style={{ backgroundImage: `url(${bgLogin})` }}
        >

          <div className="signin-header">
            <img src="./images/salis.png" alt="" className="loginImage" />
            <h1>Welcome To Salis ERP</h1>
            <p>Please enter your credentials to login!</p>
          </div>

          {/* Login Card */}
          <div className="signin-card">
            <label>UserName*</label>
            <input
              ref={userNameRef}
              type="text"
              name="user_name"
              placeholder="Email"
              onChange={handleChange}
              onKeyDown={(e) => e.key === "Enter" && userPassRef.current.focus()}
            />

            <label>Password*</label>
            <input
              ref={userPassRef}
              type="password"
              name="user_password"
              placeholder="********"
              onChange={handleChange}
              onKeyDown={(e) => e.key === "Enter" && signinAction()}
            />

            <button onClick={signinAction} disabled={ajaxReqStatus}>
              Submit
            </button>

            {/* {open && <p className="error-text">Oops !! no internet connection</p>} */}
          </div>
        </div>

        {/* Demo Credentials */}
        <div className="demo-box">
          <div className="demo-row">
            <strong>UserName: </strong>
            <span>deshitbd</span>
            <Copy size={18} className="copy-icon" onClick={() => copyCredentials("deshitbd")} />
          </div>

          <div className="demo-row">
            <strong>Password: </strong>
            <span>123456</span>
            <Copy size={18} className="copy-icon" onClick={() => copyCredentials("123456")} />
          </div>
        </div>

        {/* Modules */}
        <div className="modules">
          <h2>Salis ERP Modules</h2>
          <div className="module-list">
            {[
              "Projects Module",
              "Accounts Module",
              "Quotation Module",
              "HR & Payroll Module",
              "Service Module",
              "Inventory Module",
              "Order Module",
              "POS Module",
              "L/C Module",
              "CRM Module",
              "Purchase Module",
              "Finance Module",
              "Reports Module",
              "Sales Module",
            ].map((m) => (
              <span key={m}>{m}</span>
            ))}
          </div>
        </div>

        {/* Footer */}
        <div className="footer">
          Developed By <a href="https://www.deshit-bd.com">DeshIT-BD</a> - Hotline :
          +8801537-570379
        </div>
      </div>
      <RightSide />

    </div>
  );
};

export default SignIn;
